import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { ICashRegister } from '../interfaces';
import { CashRegisterMapper } from '../mappers';

export type IGetCashRegisterByIdRepoResponse = IRepoResponse<200, ICashRegister> | IRepoResponse<400 | 500, string>;

export type IGetCashRegisterByIdRepo = IRepo<[number | string], IGetCashRegisterByIdRepoResponse>;

export const GetCashRegisterByIdRepoType = Symbol.for('GetCashRegisterByIdRepo');

@bind(GetCashRegisterByIdRepoType)
export class GetCashRegisterByIdRepo implements IGetCashRegisterByIdRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: number | string) {
    try {
      const result = await this.httpClient.get({ url: urlMaker('/api/admin/cashboxes/info', { cashbox_id: id }) });

      if (result.status === 200) {
        const data: ICashRegister = CashRegisterMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: data,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
